const cylinderOptions = [
    { id: "1", label: "1 cyl" },
    { id: "2", label: "2 cyl" },
    { id: "3", label: "3 cyl" },
    { id: "4", label: "4 cyl" },
    { id: "5", label: "5 cyl" },
    { id: "6", label: "6 cyl" },
    { id: "8", label: "8 cyl" },
    { id: "10", label: "10 cyl" },
    { id: "12", label: "12 cyl" },
];

  // API key
  const cyclinderAPIKey = "cylinders"; 
  
  // Label
  const cyclinderLabel = "Engine Cylinders"; 
  
  export { cylinderOptions, cyclinderLabel, cyclinderAPIKey };
  